import header from "./helles-wohnzimmer.jpg";
import section1 from "./berechnung-wohnflaeche.jpg";
import section2 from "./wohnflaeche.webp";
import section3de from "./regeln-de.jpg";
import section3en from "./regeln-en.jpg";
import section4 from "./ausgebauter-dachboden.jpg";

export { header, section1, section2, section3de, section3en, section4 };
